import { Add, Check, Refresh } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import styles from "./CustomOrderNew.module.css";

import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import CustomOrderSummary from "Components/AdminPurchaseEntryNew/CustomOrderSummary";
import GetApiService from "Components/Api/getapiService";
import AlertMessage from "Components/Other Functions/AlertMessage";
import ErrorModal from "Components/Other Functions/popup";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  calculateAmount,
  convertInInvoiceWholeSaleFormat,
  getCurrentFinancialYear,
  selectStyle,
} from "utils/helpers";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";

import { a768, a769, a770, a771, a772, a773 } from "Components/Api/RootApiPath";
import Spinner from "Components/CommonComponents/Spinner";
import PaymentModule from "Components/AdminPurchaseEntryNew/PaymentModule";
import useScreenSize from "hooks/useScreenSize";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import { fetchCustomerTouncheList } from "services/Tounches";
import { fetchInvoiceNumber } from "services/invoiceServices";
import { fetchAllRates } from "services/rate";
import CustomOrderImageUpload from "./CustomOrderImageUpload";

const CustomOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [editStatus, setEditStatus] = useState(
    location.state?.editStatus || false
  );
  const [defaultValues, setDefaultValues] = useState(
    location.state?.defaultValues || {}
  );
  const fileInputRef = useRef(null);

  const orderData = location.state?.orderData || defaultValues;
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSummary, setIsSummary] = useState(false);
  const [invoiceCreateLoading, setInvoiceCreateLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [fileName, setFileName] = useState("");
  const [filteredProductOptions, setFilteredProductOptions] = useState([]);
  const [filteredDesignOptions, setFilteredDesignOptions] = useState([]);
  const [filteredPurityOptions, setFilteredPurityOptions] = useState([]);
  const [editValues, setEditValues] = useState();
  const [edit, setEdit] = useState(false);
  const [tab, setTab] = useState("Paid");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [localProductOrders, setLocalProductOrders] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  // Redux state
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const employeeFirstName = adminLoggedIn.FirstName;
  const employeeLastName = adminLoggedIn.LastName;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const apiService = new GetApiService(clientCode);
  const isSmallScreen = useScreenSize();

  // Payment calculation --------------------------------
  const [totalAmount, setTotalAmount] = useState(0); // State to store the calculated total amount
  const [paymentsArray, setPaymentsArray] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState({
    taxableAmount: 0,
    isGst: false,
    gstAmount: 0,
    additionalTax: 0,
    isAdditionalTax: false,
    discount: 0,
    courierCharge: 0,
    totalAmount: 0,
    paidAmount: 0,
  });
  // Payment calculation --------------------------------

  // Form setup
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...defaultValues,
      sku: null,
      category: null,
      product: null,
      design: null,
      purity: null,
      grossWt: "",
      stoneWt: "",
      diamondWt: "",
      netWt: "",
      size: "",
      length: "",
      color: "",
      quantity: "1",
      ratePerGram: "",
      makingPerGram: "",
      fixedMaking: "",
      fixedWt: "",
      makingPercentage: "",
      diamondPieces: "",
      diamondAmount: "",
      stoneAmount: "",
      screwType: null,
      polish: "",
      rhodium: null,
      sampleWt: "",
      remarks: "",
      productOrders: [],
      paymentTypes: [],
    },
  });

  // Watch form values
  const selectedSku = watch("sku");
  const selectedCategory = watch("category");
  const selectedProduct = watch("product");
  const selectedDesign = watch("design");
  const selectedPurity = watch("purity");
  const grossWt = watch("grossWt");
  const stoneWt = watch("stoneWt");
  const diamondWt = watch("diamondWt");
  const netWt = watch("netWt");
  const productOrders = watch("productOrders") || [];
  const paymentTypes = watch("paymentTypes") || [];
  const gstCheckbox = watch("gstCheckbox");
  const customerName = watch("customerName");
  const ratePerGram = watch("ratePerGram");
  const makingPerGram = watch("makingPerGram");
  const makingPercentage = watch("makingPercentage");
  const fixedMaking = watch("fixedMaking");
  const quantity = watch("quantity");
  const diamondAmount = watch("diamondAmount");
  const stoneAmount = watch("stoneAmount");

  // Queries
  const { data: skuOptions = [] } = useQuery({
    queryKey: ["customOrderSku", clientCode],
    queryFn: () =>
      apiService.customOrderSku().then((skus) =>
        skus.map((sku) => ({
          value: sku?.Id,
          label: sku?.StockKeepingUnit,
          categoryId: sku?.CategoryId,
          productId: sku?.ProductId,
          designId: sku?.DesignId,
          purityId: sku?.PurityId,
        }))
      ),
    refetchOnWindowFocus: false,
  });

  const { data: categoryOptions = [], isLoading: categoriesLoading } = useQuery(
    {
      queryKey: ["categories", clientCode],
      queryFn: async () => {
        const categories = await apiService.fetchAllCategories();
        return categories.map((category) => ({
          value: category.id || category.Id,
          label: category.CategoryName,
          categoryId: category.id || category.Id,
        }));
      },
      refetchOnWindowFocus: false,
    }
  );

  const { data: productOptions = [], isLoading: productsLoading } = useQuery({
    queryKey: ["productTypes", clientCode],
    queryFn: async () => {
      const products = await apiService.fetchAllProductType();
      return products.map((product) => ({
        value: product.id || product.Id,
        label: product.ProductName,
        categoryId: product.CategoryId || product.categoryId,
        productId: product.id || product.Id,
      }));
    },
    refetchOnWindowFocus: false,
  });

  const { data: designOptions = [] } = useQuery({
    queryKey: ["designs", clientCode],
    queryFn: () =>
      apiService.fetchAllDesigns().then((designs) =>
        designs.map((design) => ({
          value: design?.id,
          label: design?.DesignName,
          productId: design?.ProductId,
          designId: design?.id,
        }))
      ),
    refetchOnWindowFocus: false,
  });

  const { data: purityOptions = [] } = useQuery({
    queryKey: ["purities", clientCode],
    queryFn: () =>
      apiService.fetchAllPurities().then((purities) =>
        purities.map((purity) => ({
          value: purity?.id,
          label: purity?.PurityName,
          designId: purity?.DesignId,
        }))
      ),
    refetchOnWindowFocus: false,
  });

  const { data: lastOrderNo, isLoading: orderNoLoading } = useQuery({
    queryKey: ["lastOrderNo", clientCode],
    queryFn: async () => {
      try {
        const response = await fetch(a773, {
          // a772 to a773 updated
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ClientCode: clientCode,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch last order number");
        }

        const data = await response.json();
        console.log("Last order number response:", data);
        return data;
      } catch (error) {
        console.error("Error fetching last order number:", error);
        return null;
      }
    },
    enabled: !editStatus,
    refetchOnWindowFocus: false,
  });

  const fetchData = async () => {
    try {
      return await apiService.fetchInvoiceCustomers();
    } catch (e) {
      console.error(e);
    }
  };

  const {
    data: customerList,
    isLoading,
    refetch: RefetchCustomerList,
  } = useQuery({
    queryKey: ["getAllcustomerList"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
  });

  const { data: CustomerTounchList, refetch: customerListRefetch } = useQuery({
    queryKey: ["getCustomerTounchList", clientCode],
    queryFn: fetchCustomerTouncheList,
    refetchOnWindowFocus: false,
  });

  const {
    data: InvoiceNumber,
    isLoading: invoiceNumberIsLoading,
    refetch: InvoiceNumberRefetch,
  } = useQuery({
    queryKey: ["Invoice/fetchInvoiceNumber", clientCode],
    queryFn: fetchInvoiceNumber,
    refetchOnWindowFocus: false,
  });

  const { data: rateList } = useQuery({
    queryKey: ["rateList", clientCode],
    queryFn: fetchAllRates,
    refetchOnWindowFocus: false,
  });

  // Effects
  useEffect(() => {
    if (grossWt) {
      const grossWeight = parseFloat(grossWt) || 0;
      const stoneWeight = parseFloat(stoneWt) || 0;
      const diamondWeight = parseFloat(diamondWt) || 0;
      const netWeight = grossWeight - stoneWeight - diamondWeight;
      setValue("netWt", netWeight.toFixed(2)); // Changed to 2 decimal places
    }
  }, [grossWt, stoneWt, diamondWt, setValue]);

  useEffect(() => {
    RefetchCustomerList();
  }, [customerName?.value]);

  useEffect(() => {
    const customer = customerList?.length
      ? customerList?.find((customr) => customr?.Id == customerName?.value)
      : {};
    if (customer?.Id) {
      setValue("TotalFineGold", customer?.FineGold);
      setValue("Mobile", customer?.Mobile);
      setValue("advanceamount", customer?.AdvanceAmount);
      setValue("balanceamount", customer?.BalanceAmount);
    }
  }, [customerName?.value, customerList, setValue]);

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setValue("invoiceDate", formattedDate);
    setValue("orderDate", formattedDate);

    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + 7);
    const formattedDeliveryDate = deliveryDate.toISOString().split("T")[0];
    setValue("deliveryDate", formattedDeliveryDate);
  }, [setValue]);

  useEffect(() => {
    if (editStatus && orderData) {
      setEditValues(orderData);
      setEdit(true);

      // Populate form with order data
      setValue("customerName", {
        value: orderData.Customer.Id,
        label: `${orderData.Customer.FirstName} ${orderData.Customer.LastName}`,
      });
      setValue("mobile", orderData.Customer.Mobile);
      setValue("orderRemark", orderData.Remarks);
      setValue(
        "orderDate",
        new Date(orderData.CreatedOn).toISOString().split("T")[0]
      );
      setValue(
        "deliveryDate",
        new Date(orderData.LastUpdated).toISOString().split("T")[0]
      );
      setValue("category", {
        value: orderData.CategoryId,
        label: orderData.Category,
      });
      setValue("product", {
        value: orderData.ProductId,
        label: orderData.Product,
      });
      setValue("design", {
        value: orderData.DesignId,
        label: orderData.Design,
      });
      setValue("purity", {
        value: orderData.PurityId,
        label: orderData.Purity,
      });
      setValue("grossWt", orderData.GrossWt);
      setValue("stoneWt", orderData.StoneWt);
      setValue("diamondWt", orderData.DiamondWt);
      setValue("netWt", orderData.NetWt);
      setValue("size", orderData.Size);
      setValue("length", orderData.Length);
      setValue("quantity", orderData.Quantity);
      setValue("ratePerGram", orderData.Rate);
      setValue("makingPerGram", orderData.Making);
      setValue("fixedMaking", orderData.FixedMaking);
      setValue("fixedWt", orderData.FixedWt);
      setValue("makingPercentage", orderData.MakingPercent);
      setValue("diamondPieces", orderData.DiamondPieces);
      setValue("diamondAmount", orderData.DiamondAmount);
      setValue("stoneAmount", orderData.StoneAmt);
      setValue("screwType", {
        value: orderData.ScrewTypeId,
        label: orderData.ScrewType,
      });
      setValue("polish", orderData.Polish);
      setValue("rhodium", {
        value: orderData.RhodiumId,
        label: orderData.Rhodium,
      });
      setValue("sampleWt", orderData.SampleWt);
      setValue("remarks", orderData.Remarks);
    }
  }, [editStatus, orderData, setValue]);

  // Add useEffect to handle SKU selection and update other dropdowns
  // useEffect(() => {
  //   if (selectedSku) {
  //     const skuDetails = skuOptions.find(
  //       (sku) => sku.value === selectedSku.value
  //     );

  //     if (skuDetails) {
  //       const { categoryId, productId, designId, purityId } = skuDetails;

  //       // Category
  //       const selectedCategory = categoryOptions.find((cat) => cat.value === categoryId);
  //       setValue("category", selectedCategory || null);

  //       // Product
  //       const filteredProducts = productOptions.filter((prod) => prod.categoryId === categoryId);
  //       setFilteredProductOptions(filteredProducts);
  //       const selectedProduct = filteredProducts.find((prod) => prod.value === productId);
  //       setValue("product", selectedProduct || null);

  //       // Design
  //       const filteredDesigns = designOptions.filter((design) => design.productId === productId);
  //       setFilteredDesignOptions(filteredDesigns);
  //       const selectedDesign = filteredDesigns.find((design) => design.value === designId);
  //       setValue("design", selectedDesign || null);

  //       // Purity
  //       const filteredPurities = purityOptions.filter((purity) => purity.designId === designId);
  //       setFilteredPurityOptions(filteredPurities);
  //       const selectedPurity = filteredPurities.find((purity) => purity.value === purityId);
  //       setValue("purity", selectedPurity || null);
  //     } else {
  //       resetDependentFields();
  //     }
  //   } else {
  //     resetDependentFields();
  //   }
  // }, [
  //   selectedSku,
  //   skuOptions,
  //   categoryOptions,
  //   productOptions,
  //   designOptions,
  //   purityOptions,
  //   setValue,
  // ]);

  // Handling SKU selection

  const handleSkuChange = (selectedSku) => {
    setValue("sku", selectedSku);

    const skuDetails = skuOptions.find(
      (sku) => sku.value === selectedSku.value
    );
    if (skuDetails) {
      const { categoryId, productId, designId, purityId } = skuDetails;

      // Set Category
      const selectedCategory = categoryOptions.find(
        (cat) => cat.value === categoryId
      );
      setValue("category", selectedCategory || null);

      // Set Product based on selected Category
      const filteredProducts = productOptions.filter(
        (prod) => prod.categoryId === categoryId
      );
      setFilteredProductOptions(filteredProducts);
      const selectedProduct = filteredProducts.find(
        (prod) => prod.value === productId
      );
      setValue("product", selectedProduct || null);

      // Set Design based on selected Product
      const filteredDesigns = designOptions.filter(
        (design) => design.productId === productId
      );
      setFilteredDesignOptions(filteredDesigns);
      const selectedDesign = filteredDesigns.find(
        (design) => design.value === designId
      );
      setValue("design", selectedDesign || null);

      // Set Purity based on selected Design
      const filteredPurities = purityOptions.filter(
        (purity) => purity.designId === designId
      );
      setFilteredPurityOptions(filteredPurities);
      const selectedPurity = filteredPurities.find(
        (purity) => purity.value === purityId
      );
      setValue("purity", selectedPurity || null);
    } else {
      resetDependentFields(); // Reset dependent fields if no SKU is selected
    }
  };

  useEffect(() => {
    if (selectedSku) {
      const skuDetails = skuOptions.find((sku) => sku.value === selectedSku.value);
  
      if (skuDetails) {
        const { categoryId, productId, designId, purityId } = skuDetails;
  
        // Set Category
        const selectedCategory = categoryOptions.find((cat) => cat.value === categoryId);
        setValue("category", selectedCategory || null);
  
        // Filter and set Product
        const filteredProducts = productOptions.filter((prod) => prod.categoryId === categoryId);
        setFilteredProductOptions(filteredProducts);
        const selectedProduct = filteredProducts.find((prod) => prod.value === productId);
        setValue("product", selectedProduct || null);
  
        // Filter and set Design
        const filteredDesigns = designOptions.filter((design) => design.productId === productId);
        setFilteredDesignOptions(filteredDesigns);
        const selectedDesign = filteredDesigns.find((design) => design.value === designId);
        setValue("design", selectedDesign || null);
  
        // Filter and set Purity
        const filteredPurities = purityOptions.filter((purity) => purity.designId === designId);
        setFilteredPurityOptions(filteredPurities);
        const selectedPurity = filteredPurities.find((purity) => purity.value === purityId);
        setValue("purity", selectedPurity || null);
      } else {
        resetDependentFields(); // Reset dependent fields if no SKU is selected
      }
    } else {
      resetDependentFields(); // Reset fields if no SKU is selected
    }
  }, [selectedSku, skuOptions, categoryOptions, productOptions, designOptions, purityOptions, setValue]);
  

  useEffect(() => {
    // Handle Category selection
    if (categoryOptions.length === 1) {
      setValue("category", categoryOptions[0]);
    }

    // Handle Product selection
    if (filteredProductOptions.length === 1) {
      setValue("product", filteredProductOptions[0]);
    }

    // Handle Design selection
    if (filteredDesignOptions.length === 1) {
      setValue("design", filteredDesignOptions[0]);
    }

    // Handle Purity selection
    if (filteredPurityOptions.length === 1) {
      setValue("purity", filteredPurityOptions[0]);
    }
  }, [
    categoryOptions,
    filteredProductOptions,
    filteredDesignOptions,
    filteredPurityOptions,
    setValue,
  ]);

  const resetDependentFields = () => {
    setValue("category", null);
    setValue("product", null);
    setValue("design", null);
    setValue("purity", null);
    setFilteredProductOptions([]);
    setFilteredDesignOptions([]);
    setFilteredPurityOptions([]);
  };

  // Handlers
  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      setFileName(file.name);
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
      return () => URL.revokeObjectURL(previewUrl);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleOpenSummary = () => {
    setIsSummary(true);
  };

  const handleCloseSummary = () => {
    setIsSummary(false);
  };

  const handleTab = (selectedTab) => {
    setTab(selectedTab);
  };

  const reloadData = () => {
    setShowModal(false);
  };

  // Handling Category change
  const handleCategoryChange = (selectedOption) => {
    setValue("category", selectedOption);
    setValue("product", null);
    setValue("design", null);
    setValue("purity", null);

    // Filter products based on selected category
    const filteredProducts = productOptions.filter(
      (prod) => prod.categoryId === selectedOption.value
    );
    setFilteredProductOptions(filteredProducts);
  };

  // Handling Product change
  const handleProductChange = (selectedOption) => {
    setValue("product", selectedOption);
    setValue("design", null);
    setValue("purity", null);

    // Filter designs based on selected product
    const filteredDesigns = designOptions.filter(
      (design) => design.productId === selectedOption.value
    );
    setFilteredDesignOptions(filteredDesigns);
  };

  // Handling Design change
  const handleDesignChange = (selectedOption) => {
    setValue("design", selectedOption);
    setValue("purity", null); // Reset purity dropdown

    // Filter purities based on selected design
    const filteredPurities = purityOptions.filter(
      (purity) => purity.designId === selectedOption.value
    );
    setFilteredPurityOptions(filteredPurities);
  };

  const handleCustomerChange = (selectedOption) => {
    setValue("customerName", selectedOption);
    const selectedCustomer = customerList.find(
      (customer) => customer.Id === selectedOption.value
    );
    if (selectedCustomer) {
      setValue("mobile", selectedCustomer.Mobile);
    }
  };

  const handleMobileChange = (e) => {
    setValue("mobile", e.target.value);
  };

  // Helper functions
  const calculateItemPrice = (order) => {
    const metalAmount =
      parseFloat(order.NetWt || 0) * parseFloat(order.RatePerGram || 0);
    const makingAmount =
      parseFloat(order.MakingPerGram || 0) * parseFloat(order.NetWt || 0);
    const fixedMaking = parseFloat(order.FixedMaking || 0);
    const stoneAmount = parseFloat(order.StoneAmount || 0);
    const diamondAmount = parseFloat(order.DiamondAmount || 0);

    const totalAmount =
      metalAmount + makingAmount + fixedMaking + stoneAmount + diamondAmount;
    return totalAmount.toFixed(3);
  };

  const clearProductFields = () => {
    setValue("sku", null);
    setValue("category", null);
    setValue("product", null);
    setValue("design", null);
    setValue("purity", null);
    setValue("grossWt", "");
    setValue("stoneWt", "");
    setValue("diamondWt", "");
    setValue("netWt", "");
    setValue("size", "");
    setValue("length", "");
    setValue("color", "");
    setValue("quantity", "1");
    setValue("ratePerGram", "");
    setValue("makingPerGram", "");
    setValue("fixedMaking", "");
    setValue("fixedWt", "");
    setValue("makingPercentage", "");
    setValue("diamondPieces", "");
    setValue("diamondAmount", "");
    setValue("stoneAmount", "");
    setValue("screwType", null);
    setValue("polish", "");
    setValue("rhodium", null);
    setValue("sampleWt", "");
    setValue("remarks", "");
    setFileName("");
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleAddCustomOrder = () => {
    const formValues = getValues();

    // Validate required fields
    if (!formValues.customerName?.value) {
      toast.error("Please select a customer", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    if (!formValues.category) {
      toast.error("Please select a category", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    if (!formValues.product) {
      toast.error("Please select a product", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    if (!formValues.grossWt) {
      toast.error("Please enter gross weight", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    // Create product order object
    const newProductOrder = {
      Label: formValues.sku?.label || "",
      Category: formValues.category?.label || "",
      Product: formValues.product?.label || "",
      Design: formValues.design?.label || "",
      Purity: formValues.purity?.label || "",
      GrossWt: formValues.grossWt || "0",
      StoneWt: formValues.stoneWt || "0",
      DiamondWt: formValues.diamondWt || "0",
      NetWt: formValues.netWt || "0",
      Size: formValues.size || "",
      Length: formValues.length || "",
      Color: formValues.color || "",
      Quantity: formValues.quantity || "1",
      RatePerGram: formValues.ratePerGram || "0",
      MakingPerGram: formValues.makingPerGram || "0",
      FixedMaking: formValues.fixedMaking || "0",
      FixedWt: formValues.fixedWt || "0",
      MakingPercentage: formValues.makingPercentage || "0",
      DiamondPieces: formValues.diamondPieces || "0",
      DiamondAmount: formValues.diamondAmount || "0",
      StoneAmount: formValues.stoneAmount || "0",
      ScrewType: formValues.screwType?.label || "",
      Polish: formValues.polish || "",
      Rhodium: formValues.rhodium?.label || "",
      SampleWt: formValues.sampleWt || "0",
      Remarks: formValues.remarks || "",
      Image: fileName || "",
      // Add IDs for backend
      SkuId: formValues.sku?.value || 0,
      CategoryId: formValues.category?.value || 0,
      ProductId: formValues.product?.value || 0,
      DesignId: formValues.design?.value || 0,
      PurityId: formValues.purity?.value || 0,
      ScrewTypeId: formValues.screwType?.value || 0,
      RhodiumId: formValues.rhodium?.value || 0,
    };

    // Add to local state for display in summary
    // const currentProductOrders = watch("productOrders") || [];

    // const updatedProductOrder = {
    //   ...newProductOrder,
    //   OrderId: currentProductOrders.length + 1,
    //   Price: calculateItemPrice(newProductOrder),
    // };

    // setValue("productOrders", [...currentProductOrders, updatedProductOrder]);
    // setLocalProductOrders([...currentProductOrders, updatedProductOrder]);

    // toast.success("Product added to order successfully!", {
    //   position: "top-center",
    //   duration: 3000,
    // });

    // clearProductFields();
    // handleOpenSummary();
    // If in edit mode, update the existing order at the editIndex
    if (edit) {
      const updatedOrders = [...localProductOrders];
      updatedOrders[editIndex] = {
        ...newProductOrder,
        OrderId: localProductOrders[editIndex]?.OrderId, // Keep the existing OrderId
        Price: calculateItemPrice(newProductOrder),
      };
      setLocalProductOrders(updatedOrders); // Update local orders
      setValue("productOrders", updatedOrders); // Update form state
    } else {
      // Add new order if not in edit mode
      const updatedProductOrder = {
        ...newProductOrder,
        OrderId: localProductOrders.length + 1,
        Price: calculateItemPrice(newProductOrder),
      };
      setLocalProductOrders([...localProductOrders, updatedProductOrder]);
      setValue("productOrders", [...localProductOrders, updatedProductOrder]);
    }

    toast.success("Product added to order successfully!", {
      position: "top-center",
      duration: 3000,
    });

    clearProductFields();
    handleOpenSummary();
  };

  const handleApplyOrder = () => {
    const formValues = getValues();

    // Validate required fields
    if (!formValues.customerName?.value) {
      toast.error("Please select a customer", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    if (!formValues.category) {
      toast.error("Please select a category", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    if (!formValues.product) {
      toast.error("Please select a product", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }

    // Create product order object
    const newProductOrder = {
      Label: formValues.sku?.label || "",
      Category: formValues.category?.label || "",
      Product: formValues.product?.label || "",
      Design: formValues.design?.label || "",
      Purity: formValues.purity?.label || "",
      GrossWt: formValues.grossWt || "0",
      StoneWt: formValues.stoneWt || "0",
      DiamondWt: formValues.diamondWt || "0",
      NetWt: formValues.netWt || "0",
      Size: formValues.size || "",
      Length: formValues.length || "",
      Color: formValues.color || "",
      Quantity: formValues.quantity || "1",
      RatePerGram: formValues.ratePerGram || "0",
      MakingPerGram: formValues.makingPerGram || "0",
      FixedMaking: formValues.fixedMaking || "0",
      FixedWt: formValues.fixedWt || "0",
      MakingPercentage: formValues.makingPercentage || "0",
      DiamondPieces: formValues.diamondPieces || "0",
      DiamondAmount: formValues.diamondAmount || "0",
      StoneAmount: formValues.stoneAmount || "0",
      ScrewType: formValues.screwType?.label || "",
      Polish: formValues.polish || "",
      Rhodium: formValues.rhodium?.label || "",
      SampleWt: formValues.sampleWt || "0",
      Remarks: formValues.remarks || "",
      Image: fileName || "",
      SkuId: formValues.sku?.value || 0,
      CategoryId: formValues.category?.value || 0,
      ProductId: formValues.product?.value || 0,
      DesignId: formValues.design?.value || 0,
      PurityId: formValues.purity?.value || 0,
      ScrewTypeId: formValues.screwType?.value || 0,
      RhodiumId: formValues.rhodium?.value || 0,
    };

    // const currentProductOrders = watch("productOrders") || [];

    // const updatedProductOrder = {
    //   ...newProductOrder,
    //   OrderId: currentProductOrders.length + 1,
    //   Price: calculateItemPrice(newProductOrder),
    // };

    // setValue("productOrders", [...currentProductOrders, updatedProductOrder]);
    // setLocalProductOrders([...currentProductOrders, updatedProductOrder]);

    // toast.success("Product added to order successfully!", {
    //   position: "top-center",
    //   duration: 3000,
    // });

    // clearProductFields();
    // handleOpenSummary();

    // If in edit mode, update the existing order at the editIndex
    if (edit) {
      const updatedOrders = [...localProductOrders];
      updatedOrders[editIndex] = {
        ...newProductOrder,
        OrderId: localProductOrders[editIndex]?.OrderId, // Keep the existing OrderId
        Price: calculateItemPrice(newProductOrder),
      };
      setLocalProductOrders(updatedOrders); // Update local orders
      setValue("productOrders", updatedOrders); // Update form state
    } else {
      // Add new order if not in edit mode
      const updatedProductOrder = {
        ...newProductOrder,
        OrderId: localProductOrders.length + 1,
        Price: calculateItemPrice(newProductOrder),
      };
      setLocalProductOrders([...localProductOrders, updatedProductOrder]);
      setValue("productOrders", [...localProductOrders, updatedProductOrder]);
    }

    toast.success("Product added to order successfully!", {
      position: "top-center",
      duration: 3000,
    });

    clearProductFields();
    handleOpenSummary();
  };

  const handleSaveAndUpdateOrder = async () => {
    try {
      setInvoiceCreateLoading(true);

      const formValues = getValues();
      const productOrders = formValues.productOrders || [];

      // Validate customer selection
      if (!formValues.customerName?.value) {
        toast.error("Please select a customer", {
          position: "top-center",
          duration: 3000,
        });
        setInvoiceCreateLoading(false);
        return;
      }

      // Validate product orders
      if (productOrders.length === 0) {
        toast.error("Please add at least one product to the order", {
          position: "top-center",
          duration: 3000,
        });
        setInvoiceCreateLoading(false);
        return;
      }

      // Get customer details
      const customer = customerList.find(
        (c) => c.Id === formValues.customerName.value
      );

      if (!customer) {
        toast.error("Customer not found", {
          position: "top-center",
          duration: 3000,
        });
        setInvoiceCreateLoading(false);
        return;
      }

      // Format payments
      const payments = paymentsArray.map((payment) => ({
        Id: 0,
        CreatedOn: new Date().toISOString(),
        LastUpdated: new Date().toISOString(),
        StatusType: true,
        CustomerId: formValues.customerName?.value || 0,
        PaymentModeType: payment.paymentMode || "",
        PaymentSource: "Custom Order",
        CreditDebit: payment.paymentType === "Received" ? "Credit" : "Debit",
        Amount: payment.paymentAmount || "0",
        TransactionType: "Custom Order",
        Description: payment.paymentDescription || "",
        BranchId: BranchId || 0,
        CounterId: CounterId || 0,
        EmployeeId: EmployeeId || 0,
        CompanyId: CompanyId || 0,
        ClientCode: clientCode,
        TransactionDate: new Date().toISOString(),
      }));

      // Prepare custom order items
      const customOrderItems = productOrders.map((order) => ({
        finalPrice: calculateItemPrice(order),
        InvocieItemId: 0,
        CustomOrderId: 0,
        MRP: "",
        StoneLessPercent: "",
        CategoryName: order.Category || "Unknown",
        InvoiceStatus: "",
        ProductName: order.Product || "Unknown",
        Quantity: order.Quantity || "1",
        HSNCode: "",
        ItemCode: "",
        GrossWt: order.GrossWt || "0",
        NetWt: order.NetWt || "0",
        InvoiceId: 0,
        Quotation: 0,
        ProductId: order.ProductId || 0,
        CustomerId: formValues.customerName?.value || 0,
        MetalRate: order.RatePerGram || "0",
        MakingCharg: order.MakingPerGram || "0",
        Price: calculateItemPrice(order),
        HUIDCode: "",
        ProductCode: "",
        ProductNo: "",
        Size: order.Size || "Unknown",
        StoneAmount: order.StoneAmount || "0",
        TotalWt: "",
        PackingWeight: "",
        MetalAmount: "",
        OldGoldPurchase: true,
        RatePerGram: order.RatePerGram || "0",
        Amount: calculateItemPrice(order),
        BillType: gstCheckbox ? "true" : "false",
        PurProductNetWt: "",
        PurProductGrossWt: "",
        PurProductAmt: "",
        PurProductId: 0,
        UnlProductNetWt: "",
        UnlProductGrossWt: "",
        UnlProductAmt: "",
        UnlProductId: 0,
        FinePercentage: "",
        PurchaseInvoiceNo: "",
        HallmarkAmount: "",
        HallmarkNo: "",
        MakingFixedAmt: order.FixedMaking || "0",
        MakingFixedWastage: "",
        MakingPerGram: order.MakingPerGram || "0",
        MakingPercentage: order.MakingPercentage || "0",
        Description: order.Remarks || "",
        CuttingGrossWt: "",
        CuttingNetWt: "",
        BaseCurrency: "",
        CategoryId: order.CategoryId || 0,
        PurityId: order.PurityId || 0,
        TotalStoneWeight: order.StoneWt || "0",
        TotalStoneAmount: order.StoneAmount || "0",
        TotalStonePieces: "",
        TotalDiamondWeight: order.DiamondWt || "0",
        TotalDiamondPieces: order.DiamondPieces || "0",
        TotalDiamondAmount: order.DiamondAmount || "0",
        SKUId: order.SkuId || 0,
        SKU: order.Label || "",
        FineWastageWt: "",
        TotalItemAmount: calculateItemPrice(order),
        Pieces: "",
        DesignId: order.DesignId || 0,
        DesignName: order.Design || "Unknown",
        ClientCode: clientCode,
        DiamondSize: "",
        DiamondWeight: order.DiamondWt || "0",
        DiamondPurchaseRate: "",
        DiamondSellRate: "",
        DiamondClarity: "",
        DiamondColour: "",
        DiamondShape: "",
        DiamondCut: "",
        DiamondSettingType: "",
        DiamondCertificate: "",
        DiamondPieces: order.DiamondPieces || "0",
        DiamondPurchaseAmount: "",
        DiamondSellAmount: "",
        DiamondDescription: "",
        CreatedOn: new Date().toISOString(),
        LastUpdated: new Date().toISOString(),
        NetAmount: "",
        GSTAmount: "",
        TotalAmount: "",
        Purity: order.Purity || "Unknown",
        CompanyId: CompanyId || 0,
        BranchId: BranchId || 0,
        CounterId: CounterId || 0,
        EmployeeId: EmployeeId || 0,
        LabelledStockId: 0,
        FineSilver: "",
        FineGold: "",
        DebitSilver: "",
        DebitGold: "",
        BalanceSilver: "",
        BalanceGold: "",
        ConvertAmt: "",
        PacketId: 0,
        totalGstAmount: "",
        StoneRateKarate: "",
        StatusType: true,
        OrederId: 0,
        Stones: [],
        OrderDiamond: [],
      }));

      const requestData = {
        CustomOrderId: editStatus ? orderData.CustomOrderId : 0,
        CustomerId: formValues.customerName?.value || 1010, // Corrected fallback
        Category: productOrders[0]?.Category || "Unknown",
        Product: productOrders[0]?.Product || "Unknown",
        Design: productOrders[0]?.Design || "Unknown",
        Purity: productOrders[0]?.Purity || "Unknown",
        GrossWt: productOrders[0]?.GrossWt || "0",
        StoneWt: productOrders[0]?.StoneWt || "0",
        DiamondWt: productOrders[0]?.DiamondWt || "0",
        OrderNo: editStatus
          ? orderData.OrderNo
          : lastOrderNo?.LastOrderTrue || "",
        NetWt: productOrders[0]?.NetWt || "0",
        Size: productOrders[0]?.Size || "Unknown",
        Length: productOrders[0]?.Length || "Unknown",
        Quantity: productOrders[0]?.Quantity || "1",
        Rate: productOrders[0]?.RatePerGram || "0",
        Making: productOrders[0]?.MakingPerGram || "0",
        FixedMaking: productOrders[0]?.FixedMaking || "0",
        FixedWt: productOrders[0]?.FixedWt || "0",
        MakingPercent: productOrders[0]?.MakingPercentage || "0",
        DiamondPieces: productOrders[0]?.DiamondPieces || "0",
        DiamondAmount: productOrders[0]?.DiamondAmount || "0",
        StoneAmt: productOrders[0]?.StoneAmount || "0",
        ScrewType: productOrders[0]?.ScrewType || "Unknown",
        Polish: productOrders[0]?.Polish || "Unknown",
        Rhodium: productOrders[0]?.Rhodium || "Unknown",
        SampleWt: productOrders[0]?.SampleWt || "0",
        Remarks: formValues.orderRemark || "",
        ClientCode: clientCode,
        BillType: gstCheckbox ? "true" : "false",
        SaleType: "Custom Order",
        BalanceAmt: paymentAmount.balanceAmount || "0",
        BalanceSilver: "0",
        BalanceGold: "0",
        OrderId: 0,
        CreatedOn: new Date().toISOString(),
        LastUpdated: new Date().toISOString(),
        StatusType: "Active",
        OrderCount: productOrders.length.toString(),
        FinancialYear: getCurrentFinancialYear(),
        CustomOrderItems: customOrderItems,
        Payments: payments,
        Customer: customer || {},
      };

      // Make the API call
      const response = await fetch(editStatus ? a772 : a769, {
        // a771 to a772 updated  and a768 to a769
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const responseData = await response.text();
      console.log("Response Data:", responseData);

      if (!response.ok) {
        throw new Error(`Failed to ${editStatus ? "update" : "create"} order`);
      }

      toast.success(
        `Custom order ${editStatus ? "updated" : "created"} successfully!`,
        {
          position: "top-center",
          duration: 3000,
        }
      );

      navigate("/custom_order_list_new");
    } catch (error) {
      console.error(
        `Error ${editStatus ? "updating" : "creating"} custom order:`,
        error
      );
      toast.error(
        `Failed to ${editStatus ? "update" : "create"} custom order: ${
          error.message
        }`,
        {
          position: "top-center",
          duration: 3000,
        }
      );
    } finally {
      setInvoiceCreateLoading(false);
    }
  };

  const handleReset = () => {
    if (editStatus && id) {
      navigate(`/edit_invoice_entry_new/${id}`);
    } else {
      navigate("/invoice_entry_new");
    }
  };

  // Fetch order by ID
  const fetchOrderById = async (orderId) => {
    try {
      const response = await fetch(`${a771}`, {
        // a770 to a771 updated
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ClientCode: clientCode,
          CustomOrderId: orderId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch order");
      }
      const orderData = await response.json();
      return orderData;
    } catch (error) {
      console.error("Error fetching order:", error);
      toast.error(`Failed to fetch order: ${error.message}`, {
        position: "top-center",
        duration: 3000,
      });
    }
  };

  const handleImageUpload = (images) => {
    setUploadedImages(images);
    console.log("Uploaded Images:", images);
  };

  // Effect to calculate Net Wt and Total Amount
  useEffect(() => {
    // Calculate Net Wt
    const grossWeight = parseFloat(grossWt) || 0;
    const stoneWeight = parseFloat(stoneWt) || 0;
    const diamondWeight = parseFloat(diamondWt) || 0;
    const netWeight = grossWeight - stoneWeight - diamondWeight;
    setValue("netWt", netWeight.toFixed(2)); // Update Net Wt field

    // Calculate Metal Amount
    const rate = parseFloat(ratePerGram) || 0;
    const metalAmount = netWeight * rate;

    // Calculate Making Amount
    const makingRate = parseFloat(makingPerGram) || 0;
    const makingPercent = parseFloat(makingPercentage) || 0;
    const fixedMakingAmount = parseFloat(fixedMaking) || 0;

    let makingAmount = 0;
    if (makingRate > 0) {
      makingAmount = netWeight * makingRate;
    } else if (makingPercent > 0) {
      makingAmount = metalAmount * (makingPercent / 100);
    } else if (fixedMakingAmount > 0) {
      makingAmount = fixedMakingAmount;
    }

    // Add Diamond and Stone Amounts
    const diamondAmt = parseFloat(diamondAmount) || 0;
    const stoneAmt = parseFloat(stoneAmount) || 0;

    // Calculate Total Amount
    let total = metalAmount + makingAmount + diamondAmt + stoneAmt;

    // Multiply by Quantity
    const qty = parseInt(quantity, 10) || 1;
    total *= qty;

    // Update Total Amount
    setTotalAmount(total.toFixed(2));
  }, [
    grossWt,
    stoneWt,
    diamondWt,
    ratePerGram,
    makingPerGram,
    makingPercentage,
    fixedMaking,
    quantity,
    diamondAmount,
    stoneAmount,
    setValue,
  ]);

  useEffect(() => {
    const taxableAmount = localProductOrders.reduce((acc, item) => {
      return acc + parseFloat(item.Price || 0);
    }, 0);

    const paidAmount = paymentsArray.reduce((acc, payment) => {
      return acc + parseFloat(payment.paymentAmount || 0);
    }, 0);

    const gstPercent = gstCheckbox ? 3 : 0;
    const gstAmount = (taxableAmount * gstPercent) / 100;
    const tdsAmount = (taxableAmount * 0.1) / 100;

    const total = taxableAmount + gstAmount - (tdsAmount || 0);
    const balance = total - paidAmount;

    setPaymentAmount({
      taxableAmount: taxableAmount.toFixed(2),
      gstAmount: gstAmount.toFixed(2),
      tdsAmount: tdsAmount.toFixed(2),
      courierCharge: 0,
      discount: 0,
      paidAmount: paidAmount.toFixed(2),
      totalAmount: total.toFixed(2),
      balanceAmount: balance.toFixed(2),
    });
  }, [localProductOrders, paymentsArray, gstCheckbox]);

  return (
    <>
      <div>
        <AdminHeading />
        <>
          <div>
            <ErrorModal
              isOpen={showModal}
              onRequestClose={() => {
                setShowModal(false);
                navigate("/adminhome");
              }}
              onReload={reloadData}
              message={errorMessage}
            />

            <div className="adminMainBodyBox">
              {showError ? (
                <AlertMessage message={messageToShow} type={messageType} />
              ) : null}
            </div>
          </div>
        </>

        {!isSmallScreen && (
          <AdminBreadCrump
            title={"Custom Order"}
            companyName={"Loyalstring"}
            module={"Transactions"}
            page={"Custom Order"}
          />
        )}
      </div>

      <form className={styles.mainbox}>
        {/* Basic detail section */}
        <div className={styles.linesection} style={{ padding: "0px 20px" }}>
          <div className={styles.infoline}>
            {/* <div
              className={styles.box}
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <label>Order No: </label>
              {invoiceNumberIsLoading ? (
                <Spinner />
              ) : (
                <strong style={{ color: "blue", fontSize: "14px" }}>
                  1234
                </strong>
              )}
            </div> */}
            <div
              className={styles.box}
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <label>Order No: </label>
              {editStatus ? (
                // For edit mode, show the existing order number from orderData
                <strong style={{ color: "blue", fontSize: "14px" }}>
                  {orderData?.OrderNo || orderData?.CustomOrderId || "N/A"}
                </strong>
              ) : orderNoLoading ? (
                // For new orders, show spinner while loading
                <Spinner />
              ) : (
                // For new orders, show the fetched order number
                <strong style={{ color: "blue", fontSize: "14px" }}>
                  {lastOrderNo?.LastOrderTrue || "N/A"}
                </strong>
              )}
            </div>

            <div className={styles.dateSection}>
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  gap: "5px",
                  flexDirection: "column",
                }}
              >
                <label htmlFor="invoiceDate">Date</label>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <input
                    id="invoiceDate"
                    type="date"
                    {...register("invoiceDate")}
                    style={{
                      width: "100%",
                      padding: "5px 10px",
                      paddingRight: "30px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Top section */}
        <div className={styles.linesection}>
          <div className={styles.container}>
            {/* Customer Name */}
            <div className={styles.box}>
              <label>
                Customer Name <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div style={{ flex: "6" }}>
                  <Controller
                    name="customerName"
                    control={control}
                    rules={{
                      required: "Customer Name is required",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={
                          Array.isArray(customerList)
                            ? customerList.map((customer) => ({
                                value: customer.Id,
                                label: customer.FirstName,
                              }))
                            : []
                        }
                        isDisabled={isLoading || editStatus}
                        isSearchable={true}
                        placeholder="-- select --"
                        styles={selectStyle}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);
                          handleCustomerChange(selectedOption);
                        }}
                      />
                    )}
                  />
                </div>
                <button
                  title="Add Customer"
                  type="button"
                  onClick={() => navigate("/add_customer_new")}
                  style={{ background: "#627282", flex: "1", height: "35px" }}
                  disabled={editStatus}
                >
                  +
                </button>
              </div>
            </div>

            <div className={styles.box}>
              <label>Contact</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div style={{ flex: "6" }}>
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Mobile"
                    {...register("mobile")}
                    style={{ border: "1px solid #ddd", height: "38px" }}
                    onChange={handleMobileChange}
                  />
                </div>
              </div>
            </div>

            <div className={styles.box}>
              <label>Order Remark</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div style={{ flex: "6" }}>
                  <input
                    type="text"
                    {...register("orderRemark")}
                    placeholder="Order Remark"
                    style={{ border: "1px solid #ddd", height: "38px" }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.box}>
              <label>Order Date</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div style={{ flex: "6" }}>
                  <input
                    type="date"
                    {...register("orderDate")}
                    style={{ border: "1px solid #ddd", height: "38px" }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.box}>
              <label>Deliver Date</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                <div style={{ flex: "6" }}>
                  <input
                    type="date"
                    {...register("deliveryDate")}
                    style={{ border: "1px solid #ddd", height: "38px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles["urd-container"]}>
          <label>URD Purchase</label>
          <div className={styles.switch}>
            <input
              type="checkbox"
              id="toggleSwitch"
              className={styles.switchinput}
            />
            <label
              className={styles.switchlabel}
              htmlFor="toggleSwitch"
            ></label>
          </div>
        </div>

        {/* Middle table */}
        {isSummary ? (
          // <div style={{ padding: "20px" }}>
          <CustomOrderSummary
            handleCloseSummary={handleCloseSummary}
            productOrders={watch("productOrders")}
            fetchOrderById={fetchOrderById}
            setEditValues={setEditValues}
            setEdit={setEdit}
            setValue={setValue}
            setIsSummaryOpen={setIsSummary}
            setEditIndex={setEditIndex}
          />
        ) : (
          // </div>
          <div className={styles.tableContainer}>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Enter Sku
              </label>
              <Controller
                name="sku"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={skuOptions}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                    // onChange={(selectedOption) => {
                    //   field.onChange(selectedOption);
                    //   setValue("sku", selectedOption);
                    // }}
                    onChange={handleSkuChange}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Category
              </label>
              <Controller
                name="category"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={categoryOptions}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    isDisabled={!selectedSku}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      handleCategoryChange(selectedOption);
                    }}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Product
              </label>
              <Controller
                name="product"
                control={control}
                rules={{
                  required: selectedCategory ? "Product is required" : false,
                }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={filteredProductOptions}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    isDisabled={!selectedCategory}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      handleProductChange(selectedOption);
                    }}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Design
              </label>
              <Controller
                name="design"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={filteredDesignOptions}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    isDisabled={!selectedProduct}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      handleDesignChange(selectedOption);
                    }}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Purity
              </label>
              <Controller
                name="purity"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    key={`purity-select-${filteredPurityOptions.length}`}
                    options={filteredPurityOptions}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    isDisabled={!selectedDesign}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                    }}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Gross Wt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("grossWt", {
                  required: "Gross weight is required",
                  pattern: {
                    value: /^[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.grossWt && (
                <span className={styles.error}>{errors.grossWt.message}</span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Stone Wt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("stoneWt", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.stoneWt && (
                <span className={styles.error}>{errors.stoneWt.message}</span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Diamond Wt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("diamondWt", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.diamondWt && (
                <span className={styles.error}>{errors.diamondWt.message}</span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Net Wt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("netWt")}
                readOnly
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Size
              </label>
              <input style={{ height: "38px" }} {...register("size")} />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Length
              </label>
              <input style={{ height: "38px" }} {...register("length")} />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Types of Color
              </label>
              <Controller
                name="color"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={[
                      { value: "Yellow", label: "Yellow Gold" },
                      { value: "White", label: "White Gold" },
                      { value: "Rose", label: "Rose Gold" },
                      { value: "Green", label: "Green Gold" },
                      { value: "Black", label: "Black Gold" },
                      { value: "Blue", label: "Blue Gold" },
                      { value: "Purple", label: "Purple Gold" },
                      { value: "Champagne", label: "Champagne Gold" },
                    ]}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                  />
                )}
              />
            </div>

            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Quantity
              </label>
              <input
                style={{ height: "38px" }}
                {...register("quantity", {
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Please enter a valid number",
                  },
                  value: "1",
                })}
              />
              {errors.quantity && (
                <span className={styles.error}>{errors.quantity.message}</span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Rate/Gm
              </label>
              <input
                style={{ height: "38px" }}
                {...register("ratePerGram", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.ratePerGram && (
                <span className={styles.error}>
                  {errors.ratePerGram.message}
                </span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Making/Gm
              </label>
              <input
                style={{ height: "38px" }}
                {...register("makingPerGram", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.makingPerGram && (
                <span className={styles.error}>
                  {errors.makingPerGram.message}
                </span>
              )}
            </div>

            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Fixed Making
              </label>
              <input
                style={{ height: "38px" }}
                {...register("fixedMaking", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.fixedMaking && (
                <span className={styles.error}>
                  {errors.fixedMaking.message}
                </span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Fixed Wt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("fixedWt", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.fixedWt && (
                <span className={styles.error}>{errors.fixedWt.message}</span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Making %
              </label>
              <input
                style={{ height: "38px" }}
                {...register("makingPercentage", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.makingPercentage && (
                <span className={styles.error}>
                  {errors.makingPercentage.message}
                </span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Diamond Pieces
              </label>
              <input
                style={{ height: "38px" }}
                {...register("diamondPieces", {
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.diamondPieces && (
                <span className={styles.error}>
                  {errors.diamondPieces.message}
                </span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Diamond Amount
              </label>
              <input
                style={{ height: "38px" }}
                {...register("diamondAmount", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.diamondAmount && (
                <span className={styles.error}>
                  {errors.diamondAmount.message}
                </span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Stone Amt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("stoneAmount", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.stoneAmount && (
                <span className={styles.error}>
                  {errors.stoneAmount.message}
                </span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Screw Type
              </label>
              <Controller
                name="screwType"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={[
                      { value: 1, label: "Type 1" },
                      { value: 2, label: "Type 2" },
                      { value: 3, label: "Type 3" },
                    ]}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Polish Type
              </label>
              <Controller
                name="polish"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={[
                      { value: "HighPolish", label: "High Polish" },
                      { value: "Matte", label: "Matte Finish" },
                      { value: "Satin", label: "Satin Finish" },
                      { value: "Hammered", label: "Hammered" },
                      { value: "Brushed", label: "Brushed" },
                    ]}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                  />
                )}
              />
            </div>

            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Rhodium
              </label>
              <Controller
                name="rhodium"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={[
                      { value: 1, label: "Yes" },
                      { value: 2, label: "No" },
                    ]}
                    isSearchable={true}
                    placeholder="-- select --"
                    styles={selectStyle}
                  />
                )}
              />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Sample Wt
              </label>
              <input
                style={{ height: "38px" }}
                {...register("sampleWt", {
                  pattern: {
                    value: /^[0-9]*\.?[0-9]*$/,
                    message: "Please enter a valid number",
                  },
                })}
              />
              {errors.sampleWt && (
                <span className={styles.error}>{errors.sampleWt.message}</span>
              )}
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Remarks
              </label>
              <input style={{ height: "38px" }} {...register("remarks")} />
            </div>
            <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Upload Images{" "}
                {uploadedImages.length > 0 ? uploadedImages.length : ""}
              </label>
              <CustomOrderImageUpload
                onUpload={handleImageUpload}
                existingImages={uploadedImages}
              />
            </div>
            {/* <div className={styles.tableFeildsCO}>
              <label style={{ margin: "5px" }} htmlFor="">
                Total Amount
              </label>
              <input style={{ height: "38px" }} value={totalAmount} readOnly />
            </div> */}
          </div>
        )}

        {!isSummary && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginBottom: "20px",
              padding: "0px 10px",
            }}
          >
            <button
              type="button"
              style={{
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                fontSize: "14px",
                backgroundColor: "#0077d4",
              }}
              onClick={edit ? handleApplyOrder : handleAddCustomOrder}
            >
              <Icon style={{ fontSize: "24px" }} icon="fluent:add-32-filled" />
              {edit ? "Apply" : "Add"}
            </button>
            <button
              type="button"
              style={{
                fontSize: "14px",
                backgroundColor: "#0077d4",
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={handleOpenSummary}
            >
              <Icon style={{ fontSize: "24px" }} icon="solar:list-bold" />
              Summary
            </button>
          </div>
        )}

        {/* Bottom section */}
        <div className={styles.linesection}>
          <PaymentModule
            setPaymentsArray={setPaymentsArray}
            setPaymentAmount={setPaymentAmount}
            paymentsArray={paymentsArray}
            paymentAmount={paymentAmount}
            taxAmount={paymentAmount.taxableAmount}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "10px",
            padding: "20px 0px",
          }}
        >
          <button
            style={{
              fontSize: "12px",
              backgroundColor: "#0077d4",
              padding: "4px 6px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            type="button"
            // onClick={edit ? handleUpdateOrder : handleSaveAndUpdateOrder}
            onClick={handleSaveAndUpdateOrder}
            disabled={invoiceCreateLoading}
          >
            {invoiceCreateLoading ? <Spinner /> : <Check size={20} />}
            {edit ? "Update" : "Save"}
          </button>

          <button
            type="button"
            onClick={handleReset}
            style={{
              background: "#fff",
              fontSize: "12px",
              color: "#0077D4",
              padding: "4px 6px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              border: "1px solid #0077D4",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={invoiceCreateLoading}
          >
            <Refresh size={20} />
            Reset
          </button>

          <button
            onClick={() => {
              navigate(`/custom_order_list_new`);
            }}
            type="button"
            style={{
              fontSize: "12px",
              backgroundColor: "#0077d4",
              padding: "4px 6px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={invoiceCreateLoading}
          >
            <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />
            Order List
          </button>
        </div>
      </form>
    </>
  );
};

export default CustomOrder;
